module.exports = __webpack_public_path__ + "static/img/wcarlogo1.5bcec99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/wcarlogo1.png
// module id = RwOI
// module chunks = 0